import { useI18n } from "@/i18n";

export default function HypeExplainer() {
  const { t } = useI18n();
  return (
    <div className="mx-auto max-w-2xl pt-10" data-testid="hype-explainer-page">
      <h1 className="font-display text-4xl font-extrabold uppercase tracking-tight text-white sm:text-5xl">{t("hype.title")}</h1>
      <p className="mt-4 text-sm leading-relaxed text-slate-300">{t("hype.intro")}</p>

      <section className="hud-card mt-8 rounded-xl p-5">
        <h2 className="font-display text-xl font-bold uppercase tracking-tight text-slate-100">{t("hype.how_title")}</h2>
        <ul className="mt-3 space-y-2.5">
          {["how_1", "how_2", "how_3", "how_4", "how_5"].map((k) => (
            <li key={k} className="flex items-start gap-2 text-sm text-slate-300" data-testid={`hype-how-${k}`}>
              <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-[#00FF87] shadow-[0_0_6px_rgba(0,255,135,0.8)]" />
              {t(`hype.${k}`)}
            </li>
          ))}
        </ul>
      </section>

      <section className="hud-card mt-4 rounded-xl p-5" data-testid="hype-sources">
        <h2 className="font-display text-xl font-bold uppercase tracking-tight text-slate-100">{t("hype.sources_title")}</h2>
        <p className="mt-2 text-sm text-slate-400">{t("hype.sources_note")}</p>
        <dl className="mt-4 space-y-3">
          {["af", "news", "sportsdb", "check"].map((k) => (
            <div key={k} className="border-l-2 border-[#00F0FF]/60 pl-3" data-testid={`hype-source-${k}`}>
              <dt className="font-mono2 text-[11px] font-bold uppercase tracking-wider text-[#00F0FF]">{t(`hype.src_${k}`)}</dt>
              <dd className="mt-0.5 text-sm text-slate-300">{t(`hype.src_${k}_use`)}</dd>
            </div>
          ))}
        </dl>
        <h3 className="mt-5 font-mono2 text-[11px] font-bold uppercase tracking-wider text-slate-400">{t("hype.freq_title")}</h3>
        <p className="mt-1 text-sm leading-relaxed text-slate-300" data-testid="hype-frequency">{t("hype.freq_body")}</p>
        <h3 className="mt-5 font-mono2 text-[11px] font-bold uppercase tracking-wider text-slate-400">{t("hype.gaps_title")}</h3>
        <p className="mt-1 text-sm leading-relaxed text-slate-300" data-testid="hype-gaps">{t("hype.gaps_body")}</p>
        <h3 className="mt-5 font-mono2 text-[11px] font-bold uppercase tracking-wider text-slate-400">{t("hype.coverage_title")}</h3>
        <p className="mt-1 text-sm leading-relaxed text-slate-300" data-testid="hype-coverage">{t("hype.coverage_body")}</p>
      </section>

      <section className="hud-card mt-4 rounded-xl p-5">
        <h2 className="font-display text-xl font-bold uppercase tracking-tight text-slate-100">{t("hype.elig_title")}</h2>
        <ul className="mt-3 space-y-2.5">
          {["elig_1", "elig_2", "elig_3", "elig_4"].map((k) => (
            <li key={k} className="flex items-start gap-2 text-sm text-slate-300" data-testid={`hype-elig-${k}`}>
              <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-[#00F0FF]" />
              {t(`hype.${k}`)}
            </li>
          ))}
        </ul>
      </section>

      <section className="hud-card mt-4 rounded-xl p-5">
        <h2 className="font-display text-xl font-bold uppercase tracking-tight text-slate-100">{t("hype.mil_title")}</h2>
        <dl className="mt-3 space-y-2.5">
          {["called_up", "debuted", "started", "scored"].map((k) => (
            <div key={k} className="text-sm text-slate-300" data-testid={`hype-milestone-${k}`}>
              <dt className="font-mono2 text-[10px] uppercase tracking-wider text-[#00FF87]">{t(`state.${k}`)}</dt>
              <dd className="mt-0.5">{t(`hype.mil_${k}`)}</dd>
            </div>
          ))}
        </dl>
      </section>

      <section className="hud-card mt-4 rounded-xl p-5">
        <h2 className="font-display text-xl font-bold uppercase tracking-tight text-slate-100">{t("hype.conf_title")}</h2>
        <p className="mt-3 text-sm leading-relaxed text-slate-300" data-testid="hype-confirmed-vs-reported">{t("hype.conf_body")}</p>
      </section>

      <section className="mt-4 rounded-xl border border-[#FFD600]/40 bg-[#FFD600]/5 p-5">
        <h2 className="font-display text-xl font-bold uppercase tracking-tight text-[#FFD600]">{t("hype.not_title")}</h2>
        <ul className="mt-3 space-y-2.5">
          {["not_1", "not_2", "not_3"].map((k) => (
            <li key={k} className="flex items-start gap-2 text-sm text-slate-300" data-testid={`hype-not-${k}`}>
              <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-[#FFD600]" />
              {t(`hype.${k}`)}
            </li>
          ))}
        </ul>
      </section>
    </div>
  );
}
